import { launchpadAuthStorage } from '@/lib/launchpad/auth';
import { redirect, type LoaderFunctionArgs } from 'react-router';

/** 런치패드 위저드 라우트 가드 — 미인증 시 해당 런치패드의 로그인 페이지로 보낸다. */
export function requireLaunchpadAuth({ params }: LoaderFunctionArgs) {
  if (!launchpadAuthStorage.isAuthenticated()) {
    return redirect(`/launchpad-login?id=${params.id}`);
  }
  return null;
}

/** 런치패드 로그인 페이지 진입 시 이전 세션을 항상 비운다. */
export function clearLaunchpadAuth() {
  launchpadAuthStorage.clearAll();
  return null;
}
